import {
  BrandAsset,
  Link,
  Modal,
  ModalTrigger,
  Text,
  useColors,
  LinkButton,
} from "@certn/cascadia-react";
import {
  getApplicantPortalTermsOfUseUrl,
  getPrivacyPolicyUrl,
} from "@certn/utils";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";

import { LanguageModal } from "./LanguageModal";
import { useUser } from "../../hooks/api/useUser";
import { useLanguage } from "../../hooks/useLanguage";

export function AppFooter() {
  const { currentLanguageLabel } = useLanguage();
  const { details: userDetails } = useUser();

  const colors = useColors();
  const privacyPolicyUrl = getPrivacyPolicyUrl(currentLanguageLabel);
  const applicantPortalTermsOfUseUrl =
    getApplicantPortalTermsOfUseUrl(currentLanguageLabel);

  return (
    <>
      <div
        className={css({
          display: "flex",
          gap: "var(--space-4)",
        })}
      >
        {userDetails && (
          // TODO CHEESE-130 replace this with packages/auth/src/LanguageModal.tsx
          <ModalTrigger
            trigger={() => (
              <LinkButton
                testID="footer-language-link"
                textStyle="global/body-secondary"
                textColor="text-weak"
                leftIcon="language"
              >
                {currentLanguageLabel}
              </LinkButton>
            )}
          >
            <Modal>
              <LanguageModal />
            </Modal>
          </ModalTrigger>
        )}
        <Link
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href={privacyPolicyUrl}
          testID="footer-privacy-policy-link"
          target="_blank"
        >
          <Trans>Privacy policy</Trans>
        </Link>
        <Link
          linkStyle="monochrome"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href={applicantPortalTermsOfUseUrl}
          testID="footer-terms-of-use-link"
          target="_blank"
        >
          <Trans>Terms of use</Trans>
        </Link>
      </div>
      <Text color="text-weak" testID="footer-powered-by-link">
        <Trans>
          Powered by{" "}
          <BrandAsset
            height="18"
            width="62"
            type="full"
            brand="certn"
            fill={colors["icon-base"]}
            className={css({ verticalAlign: "middle" })}
          />
        </Trans>
      </Text>
    </>
  );
}
